import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as categories from 'catalog/actions/categories';
import {Button, ListGroupItem} from 'reactstrap';
import CategoryDetail from 'catalog/containers/CategoryDetail';
import autobind from 'autobind-decorator'

@connect(
    state => {
        return {
            activeSubcategory: state.categories.activeSubcategory
        }
    },
    dispatch => {
        return {
            chooseCategory: (category) => {
                dispatch(categories.chooseCategory(category));
            },
            unchooseCategory: (category) => {
                dispatch(categories.unchooseCategory(category));
            },
        }
    }
)
export default class SubCategory extends Component {

    chooseCategory(category) {
        const active = this.props.activeSubcategory;
        if (active && category.id === active.id) {
            this.props.unchooseCategory(category);
        } else {
            this.props.chooseCategory(category);
        }
    }

    @autobind
    isActive() {
        const {category, activeSubcategory} = this.props
        return activeSubcategory && category.id === activeSubcategory.id
    }

    render() {
        const {
            index, category
        } = this.props;
        const indexOffset = 1;
        return (
            <ListGroupItem>
                <Button
                    color={'link'}
                    onClick={() => this.chooseCategory(category)}
                >
                    {index + indexOffset}. {category.name}
                </Button>
                {
                    this.isActive() &&
                    <CategoryDetail/>
                }
            </ListGroupItem>


        )
    }
}
